import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from '../api/bff-prompts';
import { map } from 'rxjs/operators';

export interface GrupoAcesso {
  grupo_id?: number;
  grupo_nome: string;
  grupo_descricao: string;
  grupo_status: string;
}

@Injectable({
  providedIn: 'root',
})
export class GrupoAcessoService {
  constructor(private apiService: ApiService) {}

  listarGrupoAcesso(): Observable<GrupoAcesso[]> {
    return this.apiService
      .get<{ message: string; data: GrupoAcesso[] }>('grupo-acesso/')
      .pipe(map((response) => response.data));
  }

  criarGrupoAcesso(grupoAcesso: GrupoAcesso): Observable<GrupoAcesso> {
    return this.apiService.post<GrupoAcesso>('grupo-acesso/', grupoAcesso);
  }

}
